import * as React from 'react';
import { Check } from '@wix/wix-ui-icons-common';
import s from '../solution-page-views/solution-overview/solution-overview.scss';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { Box, TextButton } from '@wix/design-system';

export interface IBenefitWrapperProps extends Partial<WithTranslationProps> {
  index: number;
  benefit: string;
  appId: string;
  shouldReplace: boolean;
}
export class BenefitPreviewWrapper extends React.Component<
  IBenefitWrapperProps,
  any
> {
  render() {
    return this.props.shouldReplace ? (
      <Box
        key={this.props.index}
        align="center"
        direction="horizontal"
        verticalAlign="middle"
        marginBottom="8px"
        inline
      >
        <Check size="18" className={s.overViewCheckMark} /> &nbsp; &nbsp;{' '}
        <TextButton
          dataHook={`benefit-${this.props.index}`}
          as="a"
          href={`https://dev.wix.com/dc3/my-apps/${this.props.appId}/market/info/basic-info`}
          target="_blank"
        >
          {this.props.benefit}
        </TextButton>
      </Box>
    ) : !this.props.shouldReplace && this.props.benefit ? (
      this.props.children
    ) : null;
  }
}

export const fillWithPreviewBenefits = (
  benefits: string[],
  t: any,
  isPreview: boolean,
): { benefit: string; shouldReplace: boolean }[] => {
  const previewBenefits = [
    { benefit: t('solution.page.preview.benefit1'), shouldReplace: true },
    { benefit: t('solution.page.preview.benefit2'), shouldReplace: true },
    { benefit: t('solution.page.preview.benefit3'), shouldReplace: true },
    { benefit: t('solution.page.preview.benefit4'), shouldReplace: true },
  ];
  return !isPreview || benefits.length > 3
    ? benefits.map((benefit) => {
        return { benefit, shouldReplace: false };
      })
    : previewBenefits.map((ctaBenefit, index) =>
        index < benefits.length
          ? { benefit: benefits[index], shouldReplace: false }
          : ctaBenefit,
      );
};
